/*
 * Пузырь мультиканальной ленты брони (обновлённый макет чата). Анимации появления нет — её нет
 * и в макете (проверено грепом: `animation:` в ленте не встречается), поэтому `opacity` у
 * `.sending` работает: перебивать его нечем.
 */
.bubble {
  display: flex;
  flex-direction: column;
  gap: 3px;
  /* Ширину задаёт ПОТРЕБИТЕЛЬ: 86% в карточке брони, 78% на экране «Чаты». Фолбэк — число карточки. */
  max-width: var(--bubble-max, 86%);
  padding: 7px 12px 6px;
  border-radius: 14px;
  font-size: 13px;
  line-height: 1.42;
}

.text {
  /* Сырой текст гостя: переносы настоящие, длинная ссылка без пробелов иначе вылезла бы за пузырь. */
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.incoming {
  align-self: flex-start;
  border: 1px solid var(--line-2);
  border-bottom-left-radius: 5px;
  background: var(--panel);
}

/* У исходящего границы нет — так в макете, это не пропуск. */
.outgoing {
  align-self: flex-end;
  border-bottom-right-radius: 5px;
  background: var(--accent);
  color: var(--on-accent);
}

/* Сообщение ещё в пути. Дизайна в макете нет — приглушаем, оставаясь в его языке. */
.sending {
  opacity: 0.6;
}

/* Тег отправителя на нашей стороне: имя менеджера или «ИИ». У входящих его нет. */
.sender {
  font-size: 10.5px;
  font-weight: 600;
}

.incoming .sender {
  color: var(--ink-3);
}

.outgoing .sender {
  opacity: 0.82;
}

/* Вложение — плитка с иконкой файла, именем и размером. Скачиваемое — ссылка. */
.attach {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 2px;
  padding: 7px 10px;
  border-radius: 10px;
  color: inherit;
  text-decoration: none;
}

.incoming .attach {
  border: 1px solid var(--line-2);
  background: color-mix(in oklch, var(--sunk) 60%, var(--panel));
}

.outgoing .attach {
  background: color-mix(in oklch, var(--on-accent) 15%, transparent);
}

a.attach {
  cursor: pointer;
}

a.attach:hover {
  border-color: color-mix(in oklch, var(--accent) 34%, var(--line));
}

.attachIcon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.attachBody {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.3;
}

.attachName {
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachSize {
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 9.5px;
  opacity: 0.7;
}

/* Мета-строка внизу пузыря: бейдж канала + время с галочками, у правого края. */
.meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 1px;
}

.channel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9.5px;
  font-weight: 500;
}

.incoming .channel {
  color: var(--ink-3);
}

.outgoing .channel {
  opacity: 0.78;
}

.channelDot {
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--ch);
}

.time {
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 9.5px;
  white-space: nowrap;
}

.incoming .time {
  color: var(--ink-4);
}

/* У исходящего время не красится своим токеном, а гасится прозрачностью — так в макете. */
.outgoing .time {
  opacity: 0.75;
}

/*
 * «Не отправлено · Повторить» — под своим пузырём, СНАРУЖИ него: красный на `--accent` нечитаем
 * (1.05 : 1, измерено зондом), а на `--panel` ленты берёт AA (5.05 : 1).
 */
.failed {
  display: inline-flex;
  align-self: flex-end;
  align-items: center;
  gap: 7px;
  margin-top: -4px;
  padding: 2px 4px;
  font-size: 11px;
  color: var(--st-cancel);
}

.failedDot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--st-cancel);
}

.action {
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.action:hover {
  color: var(--ink);
}
